window.__machineAddonLoaded = true;

const MACHINE_VARIANT_ID = 57065546383695;
const MACHINE_ALWAYS_QTY_ONE = true;

function findMainCheckbox() {
  return document.querySelector('form [data-machine-addon-checkbox]');
}

function findForms() {
  return Array.from(document.querySelectorAll('form')).filter((f) => {
    const action = (f.getAttribute('action') || '').toLowerCase();
    return action.includes('/cart/add') || !!f.querySelector('input[name="id"]');
  });
}

function getVariantId(form) {
  const input = form.querySelector('input[name="id"]');
  const v = Number(input ? input.value : NaN);
  return Number.isFinite(v) && v > 0 ? v : null;
}

function getQty(form) {
  const input = form.querySelector('input[name="quantity"]');
  const v = Number(input ? input.value : 1);
  return Number.isFinite(v) && v > 0 ? v : 1;
}

async function addOne(id, quantity) {
  const res = await fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id, quantity }),
  });

  const text = await res.text();
  if (!res.ok) throw new Error(text || 'Cart add failed');
  try {
    return JSON.parse(text);
  } catch {
    return text;
  }
}

function afterAdd() {
  window.location.href = '/cart';
}


function bind() {
  const checkbox = findMainCheckbox();
  const forms = findForms();
  if (!checkbox || !forms.length) return;

  for (const form of forms) {
    if (form.dataset.machineAddonBound === '1') continue;
    form.dataset.machineAddonBound = '1';

    form.addEventListener(
      'submit',
      async (e) => {
        if (!checkbox.checked) return;

        e.preventDefault();
        e.stopImmediatePropagation();

        const mainVariantId = getVariantId(form);
        if (!mainVariantId) {
          alert('Variante konnte nicht erkannt werden. Bitte Datum auswählen und erneut versuchen.');
          return;
        }

        const qty = getQty(form);

        try {
          await addOne(mainVariantId, qty);

          const machineQty = MACHINE_ALWAYS_QTY_ONE ? 1 : qty;
          await addOne(Number(MACHINE_VARIANT_ID), machineQty);

          afterAdd();
        } catch (err) {
          console.error(err);
          alert(String(err && err.message ? err.message : err));
        }
      },
      true
    );
  }
}

document.addEventListener('DOMContentLoaded', bind);
document.addEventListener('shopify:section:load', bind);